export type ExtraData = {
    [key: string]: any;
};

export enum Severity {
    Error = 'error',
    Info = 'info',
    Warning = 'warning',
}
